import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Directive } from '@angular/core';
import { Product } from './product';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthenticationService } from '@app/auth';

const LATESTVIDEOS = 'menu/latest_videos';
const FOOTERLOGO = 'logo';
const FOOTERMENU = 'footer-1';
const FOOTERSOCIAL = 'social-media-menu';
const FOOTERAPPSTORE = 'app-store';
const FOOTERMAINMENU = 'footer-2';
const FOOTERRESPONSIVEMENU = 'footer-mobile-menu';
const ACTIVITYCATEGORIES = 'menu/activity';
const ACTIVITYWHATTODO = 'what-to-do';
const ACTIVITYWHATTOSEE = 'what-to-see';
const ACTIVITYWHERETOSTAY = 'where-to-stay';
const HEADERMAINMENU = 'assets/json/headerMainMenu.json';
const HEADERESPONSIVEMENU = 'assets/json/where-to-stay.json';
const MENU = 'menu';
const INNERISLANDSWITHACCOM = 'menu/innerisland_with_accommodation';
const INNERISLANDSWITHOUTACCOM = 'menu/innerisland_with_out_accommodation';
const OUTERISLANDSWITHACCOM = 'menu/outerisland_with_accommodation';
const OUTERISLANDSWITHOUTACCOM = 'menu/outerisland_without_accommodation';
const INNERISLANDSBANNERANDCONTENT = 'listingContents/inner-islands';
const OUTERISLANDSBANNERANDCONTENT = 'listingContents/outer-islands';
const ISLANDSIMAGEGALLERY = 'listingContents/image-gallery';
const CROWDRIFFSEARCH = 'media/crowdriff';
const BLOGS = 'blogs';
const BANNERVIDEOS = 'bannervideos';
const MEDIACENTERBANNER = 'listingContents/media-center';
const ISLANDGROUPS = 'island/groups';
const ISLANDGROUPSDETAILS = 'island/groups';
const POPULAR_SEARCH_KEYWORDS = 'popular-search-keywords';
const FOOTER_TC_PRIVACY_POILICY = 'footer-3';
const GETUSERNAME = 'get-user-name';
const HIGHLIGHTSDES = 'highlights_latest_list_desc';
const HIGHLIGHTS = 'highlights_latest_list';
const POPULAR_HIGHLIGHTS = 'highlights_latest_list_desc_like';
const A_TO_Z_HIGHLIGHTS = 'highlights_latest_list_asc_name';
const Z_TO_A_HIGHLIGHTS = 'highlights_latest_list_desc_name';
const FormatJson = '?_format=json';
const TESTIMONIAL = 'testimonials';
const BLOGLISTINGPAGE = 'menu/blog-listing-page';
const BLOGLIKE = 'blog_like';
const ANONYMOUS_BLOG_LIKE = 'anonymous_blog_like';
const NODE = 'node';

@Injectable()
export class ProductService {
  deviceInfo: any;
  deviceName: any;
  imageUrl = environment.BaseURL.toLowerCase();
  private sessionName: any;
  private sessionUserId: number;

  constructor(
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private deviceService: DeviceDetectorService
  ) {
    this.epicFunction();
    //this.patchOldLikesCount();
  }

  /* set userid in session */
  setSessionUserId(val: any) {
    this.sessionUserId = val;
  }
  getSessionUserId() {
    return this.sessionUserId;
  }

  /* set name in session */
  setSessionName(val: any) {
    this.sessionName = val;
  }

  getSessionName() {
    return this.sessionName;
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile(); // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    const isTablet = this.deviceService.isTablet(); // returns if the device us a tablet (iPad etc)
    const isDesktopDevice = this.deviceService.isDesktop(); // returns if the app is running on a Desktop browser.
    if (isMobile == true) {
      this.deviceName = 'thumbnail';
    } else if (isTablet == true) {
      this.deviceName = 'medium';
    } else {
      this.deviceName = 'large';
    }
  }
  /**
   * get Latest videos
   */
  getLatestvideos() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${LATESTVIDEOS}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get Banner Videos
   */
  getBannerVideos() {
    return this.http
      .get<any>(`${environment.apiSearchBaseURL.toLowerCase()}/${BANNERVIDEOS}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  updateBlogUri(data: any) {
    if (data.results) {
      data.results.forEach((item: any) => {
        if (item.uri && item.uri !== '' && item.uri.indexOf('http://staging-admin.sey.travel') > -1) {
          item.uri = item.uri.replace('http://staging-admin.sey.travel', this.imageUrl);
        }
        if (item.uri && item.uri.indexOf('http') < 0 && item.uri.indexOf('https') < 0) {
          item.uri = this.imageUrl + item.uri;
        }
      });
    }
    return data;
  }
  /**
   * get High light Small
   */
  getHighlightSmall() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${HIGHLIGHTS}`)
      .toPromise()
      .then((data) => {
        return this.updateBlogUri(data);
      });
  }
  getBlogViewNode(item: any) {
    let viewNode = item.view_node;

    // Find the position of "highlights" and keep everything from there
    const highlightsIndex = viewNode.indexOf('highlights/');
    if (highlightsIndex !== -1) {
      viewNode = viewNode.slice(highlightsIndex); // Keep everything from "/highlights/" onward
    } else {
      // If "highlights" is not found, assume the original path
      viewNode = `highlights/${viewNode.replace(/^\/+/, '')}`;
    }

    return viewNode;
  }
  getPopularHilights(pageNo: any, language: any, itemCode?: any) {
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    let url = `${environment.adminBaseURL.toLowerCase()}/${POPULAR_HIGHLIGHTS}/${language}${FormatJson}&page=${pageNo}`;
    if (itemCode && itemCode.length > 0) {
      url = `${environment.adminBaseURL.toLowerCase()}/${POPULAR_HIGHLIGHTS}/${language}/${itemCode}${FormatJson}&page=${pageNo}`;
    }
    return (
      this.http
        .get<any>(url)
        .toPromise()
        // .then((res) => <Product[]>res.data)
        .then((data) => {
          return this.updateBlogUri(data);
        })
    );
  }
  getHighlightSmallPaging(pageNo: any, language: any, itemCode?: any) {
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    let url = `${environment.adminBaseURL.toLowerCase()}/${HIGHLIGHTS}/${language}${FormatJson}&page=${pageNo}`;
    if (itemCode && itemCode.length > 0) {
      url = `${environment.adminBaseURL.toLowerCase()}/${HIGHLIGHTS}/${language}/${itemCode}${FormatJson}&page=${pageNo}`;
    }
    return (
      this.http
        .get<any>(url)
        .toPromise()
        // .then((res) => <Product[]>res.data)
        .then((data) => {
          return this.updateBlogUri(data);
        })
    );
  }
  getSpecialInterestBlogs(pageNo: any, language: any, itemCode?: any) {
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    let url = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_interest/${language}/all/${itemCode}${FormatJson}&page=${pageNo}`;
    return this.http
      .get<any>(url)
      .toPromise()
      .then((data) => {
        return this.updateBlogUri(data);
      });
  }
  getBlogsByAlphabet(pageNo: any, language: any, sortValue: any, itemCode: any) {
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    let val = A_TO_Z_HIGHLIGHTS;
    if (sortValue === 'Z to A') {
      val = Z_TO_A_HIGHLIGHTS;
    }
    let url = `${environment.adminBaseURL.toLowerCase()}/${val}/${language}${FormatJson}&page=${pageNo}`;
    if (itemCode && itemCode.length > 0) {
      url = `${environment.adminBaseURL.toLowerCase()}/${val}/${language}/${itemCode}${FormatJson}&page=${pageNo}`;
    }
    return (
      this.http
        .get<any>(url)
        .toPromise()
        // .then((res) => <Product[]>res.data)
        .then((data) => {
          return this.updateBlogUri(data);
        })
    );
  }
  getHighlightSmallPagingDescOrder(pageNo: any, language: any, itemCode?: any) {
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    let url = `${environment.adminBaseURL.toLowerCase()}/${HIGHLIGHTSDES}/${language}${FormatJson}&page=${pageNo}`;
    if (itemCode && itemCode.length > 0) {
      url = `${environment.adminBaseURL.toLowerCase()}/${HIGHLIGHTSDES}/${language}/${itemCode}${FormatJson}&page=${pageNo}`;
    }
    return (
      this.http
        .get<any>(url)
        .toPromise()
        // .then((res) => <Product[]>res.data)
        .then((data) => {
          return this.updateBlogUri(data);
        })
    );
  }

  getFeaturedBlogs(language: string) {
    language = language.toLowerCase();

    if (language === 'pt') language = 'pt-br';
    if (language === 'zh') language = 'zh-hans';

    let url = '';

    if (language === 'en') {
      url = `${environment.adminBaseURL.toLowerCase()}/blogs/featured`;
    } else {
      url = `${environment.adminBaseURL.toLowerCase()}/${language}/blogs/featured`;
    }

    return this.http.get<any>(url).toPromise();
  }

  /**
   * get Footer Logo
   */
  getFooterLogo() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${FOOTERLOGO}`)
      .toPromise()
      .then((result) => {
        return result;
      });
  }

  get360Info() {
    let language = localStorage.getItem('language');
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    return this.http
      .get<any>(`${environment.adminBaseURL.toLowerCase()}/explore360/${language}`)
      .toPromise()
      .then((result) => {
        if (result && result.results && result.results.length > 0) {
          return result.results.sort((a: any, b: any) => {
            const priorityA = parseInt(a.field_priority, 10) || 999;
            const priorityB = parseInt(b.field_priority, 10) || 999;
            return priorityA - priorityB;
          });
        } else {
          return [];
        }
      });
  }

  /**
   * get Footer Menu
   */
  getFooterMenu() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${FOOTERMENU}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get Footer Social Network
   */
  getFooterSocialNW() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${FOOTERSOCIAL}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get Footer App Stores
   */
  getFooterAppStores() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${FOOTERAPPSTORE}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get Footer Main Menu
   */
  getFooterMainMenu() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${FOOTERMAINMENU}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  getFooterTCPrivacy() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${FOOTER_TC_PRIVACY_POILICY}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get categories
   */
  getcategories() {
    return this.http
      .get<any>('../assets/json/products-small.json')
      .toPromise()
      .then((res) => <Product[]>res.data)
      .then((data) => {
        return data;
      });
  }
  /**
   * get categories tab
   */

  // getcategoriestab() {
  //   return this.http
  //     .get<any>('../assets/json/categories.json')
  //     .toPromise()
  //     .then((res) => <Product[]>res.data)
  //     .then((data) => {
  //       return data;
  //     });
  // }
  /**
   * get What To Do Tab
   */
  getWhatToDoTab() {
    return this.http
      .get<any>('../assets/json/what-to-do.json')
      .toPromise()
      .then((res) => <Product[]>res.data)
      .then((data) => {
        return data;
      });
  }
  /**
   * get Activity categories
   */
  getActivitycategories() {
    let headers = new HttpHeaders();
    headers = headers.set('agent', this.deviceName);
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${ACTIVITYCATEGORIES}`, {
        headers: headers,
      })
      .toPromise()
      .then((res) => <Product[]>res)
      .then((data) => {
        if (data && Array.isArray(data)) {
          data.forEach((item: any) => {
            if (item.image && item.image !== '' && item.image.indexOf('http://staging-admin.sey.travel') > -1) {
              item.image = item.image.replace('http://staging-admin.sey.travel', this.imageUrl);
            }
            if (item.image && item.image.indexOf('http') < 0 && item.image.indexOf('https') < 0) {
              item.image = this.imageUrl + item.image;
            }
          });
        }
        return data;
      });
  }
  /**
   * get What To Do
   */
  getWhatToDo() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${ACTIVITYWHATTODO}`)
      .toPromise()
      .then((res) => <Product[]>res)
      .then((data) => {
        return data;
      });
  }
  /**
   * get What To See
   */
  getWhatToSee() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${ACTIVITYWHATTOSEE}`)
      .toPromise()
      .then((res) => <Product[]>res)
      .then((data) => {
        return data;
      });
  }
  /**
   * get Where To Stay
   */
  getWhereToStay() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${ACTIVITYWHERETOSTAY}`)
      .toPromise()
      .then((res) => <Product[]>res)
      .then((data) => {
        return data;
      });
  }
  /**
   * get Footer Responsive
   */
  getFooterResponsive() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${FOOTERRESPONSIVEMENU}`)
      .toPromise()
      .then((res) => <Product[]>res)
      .then((data) => {
        return data;
      });
  }
  /**
   * get Header Main Menu
   */
  getHeaderMainMenu() {
    return this.http
      .get<any>('../assets/json/headerMainMenu.json')
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get Header Responsive Menu
   */
  getHeaderResponsiveMenu() {
    return this.http
      .get<any>('../assets/json/where-to-stay.json')
      .toPromise()
      .then((data) => {
        return data;
      });
  }

  updateUri(data: any) {
    if (data && Array.isArray(data)) {
      data.forEach((item: any) => {
        if (item.uri && item.uri !== '' && item.uri.indexOf('http://staging-admin.sey.travel') > -1) {
          item.uri = item.uri.replace('http://staging-admin.sey.travel', this.imageUrl);
        }
        if (item.uri && item.uri.indexOf('http') < 0 && item.uri.indexOf('https') < 0) {
          item.uri = this.imageUrl + item.uri;
        }
      });
    }
    return data;
  }

  /**
   * get Inner Islands With Accommodation
   */

  getInnerIslandsWithAccom() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${INNERISLANDSWITHACCOM}`)
      .toPromise()
      .then((data) => {
        return this.updateUri(data);
      });
  }
  /**
   * get Inner Islands Without Accommodation
   */
  getInnerIslandsWithoutAccom() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${INNERISLANDSWITHOUTACCOM}`)
      .toPromise()
      .then((data) => {
        return this.updateUri(data);
      });
  }
  /**
   * get outer Islands with Accommodation
   */
  getOuterIslandsWithAccom() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${OUTERISLANDSWITHACCOM}`)
      .toPromise()
      .then((data) => {
        return this.updateUri(data);
      });
  }
  /**
   * get Outer Islands without Accommodation
   */
  getOuterIslandsWithoutAccom() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${OUTERISLANDSWITHOUTACCOM}`)
      .toPromise()
      .then((data) => {
        return this.updateUri(data);
      });
  }
  /**
   * get Inner Islands banner and content
   */
  getinnerIslandsBannerAndContent() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${INNERISLANDSBANNERANDCONTENT}`)
      .toPromise()
      .then((data) => {
        return this.updateUri(data);
      });
  }
  /**
   * get Outer Islands banner and content
   */
  getouterIslandsBannerAndContent() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${OUTERISLANDSBANNERANDCONTENT}`)
      .toPromise()
      .then((data) => {
        return this.updateUri(data);
      });
  }
  /**
   * get  Islands Details
   */
  getIslandDetails(view_node: any) {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${view_node}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get contact details
   */
  getContactDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL.toLowerCase() + '/menu/contact-us');
  }
  /**
   * get contact details
   */
  getDowloadsDetails(): Observable<any> {
    let language = localStorage.getItem('language');
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    if (language.toLowerCase() !== 'en') {
      return this.http.get(
        environment.BaseURL.toLowerCase() + '/' + language.toLowerCase() + '/downloads?_format=json'
      );
    } else {
      return this.http.get(environment.BaseURL.toLowerCase() + '/downloads?_format=json');
    }
  }

  public getDownloadBrochure(): Observable<any> {
    let language = localStorage.getItem('language');
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    if (language.toLowerCase() !== 'en') {
      return this.http.get(environment.BaseURL + '/downloadapi' + '/' + language.toLowerCase());
    } else {
      return this.http.get(environment.BaseURL + '/downloadapi');
    }
  }
  public getSuggestions(val: any): Observable<any> {
    let language = localStorage.getItem('language');
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    return this.http.get<any>(
      `${environment.adminBaseURL.toLowerCase()}/highlights_asc_nameall/${language.toLowerCase()}?title=${val.trim()}`
    );
  }
  public getBlog(): Observable<any> {
    let language = localStorage.getItem('language');
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    return this.http.get<any>(
      `${environment.adminBaseURL.toLowerCase()}/highlights_asc_nameall/${language.toLowerCase()}`
    );
  }

  /**
   * get privacy policy details
   */
  getPrivacyPolicyDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL.toLowerCase() + '/menu/privacy-policy');
  }
  /**
   * get Terms and Conditions Details
   */
  getTermsAndConditionsDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL.toLowerCase() + '/menu/terms-use');
  }
  /**
   * get Faq  Details
   */
  getFaqDetails(): Observable<any> {
    //return this.http.get(environment.apiBaseURL.toLowerCase() + '/menu/faq');
    return this.http.get(environment.BaseURL.toLowerCase() + '/webfaqapi');
  }

  /**
   * save contact Details
   */
  saveContacts(contactData: any): Observable<any> {
    var token = localStorage.getItem('token');
    return this.http.post(
      environment.adminBaseURL.toLowerCase() + '/entity/contact_message',
      {
        contact_form: [{ target_id: 'feedback' }],
        name: [{ value: contactData.name }],
        mail: [{ value: contactData.email }],
        subject: [{ value: contactData.subject }],
        message: [{ value: contactData.message }],
      },
      { headers: new HttpHeaders({ 'X-CSRF-Token': JSON.stringify(token) }) }
    );
  }
  /**
   * get FAQ
   */
  getFaq(): Observable<any> {
    return this.http.get(environment.apiBaseURL.toLowerCase() + '/menu/faq');
  }

  /**
   * get Media Center Gallery
   * @param mediaType
   */
  getMediaCenterGallery(mediaType: string) {
    return this.http
      .get<any>(`${environment.crowdriffBaseURL.toLowerCase()}/${CROWDRIFFSEARCH}/${mediaType}`)
      .toPromise()
      .then((data) => {
        return data.data;
      });
  }
  getMediaInstagramGallery(mediaType: string) {
    return this.http
      .get<any>(`${environment.crowdriffBaseURL.toLowerCase()}/${CROWDRIFFSEARCH}/${mediaType}`)
      .toPromise()
      .then((data) => {
        return data.data;
      });
  }

  /**
   * get High Lights Blob Details
   * @param view_node
   */
  getHighLightsBlobDetails(nodeid: any, view_node: any) {
    let viewNode = view_node;
    if (viewNode.startsWith('/')) {
      viewNode = viewNode.replace(/^\/+/, ''); // Removes all leading slashes (single or multiple)
    }
    // Ensure the path starts with "highlights/"
    if (!viewNode.startsWith('highlights/')) {
      viewNode = `highlights/${viewNode}`;
    }

    // Log the result to verify the output format

    return (
      this.http
        .get<any>(`${environment.apiBaseURL.toLowerCase()}/${BLOGS}/${nodeid}/${viewNode}`)
        .toPromise()
        // .then((res) => <Product[]>res.data)
        .then((data) => {
          if (data && data.relatedBlogs) {
            data.relatedBlogs.forEach((item: any) => {
              if (item.uri && item.uri !== '' && item.uri.indexOf('http://staging-admin.sey.travel') > -1) {
                item.uri = item.uri.replace('http://staging-admin.sey.travel', this.imageUrl);
              }
              if (item.uri && item.uri.indexOf('http') < 0 && item.uri.indexOf('https') < 0) {
                item.uri = this.imageUrl + item.uri;
              }
            });
          }
          return data;
        })
    );
  }
  /**
   * get High Lights Blob Details
   * @param view_node
   */
  getCreatedBy(userId: any) {
    return this.http
      .get<any>(`${environment.adminBaseURL.toLowerCase()}/${GETUSERNAME}/${userId}?_format=json`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get Media Center Banner Content
   */
  getMediaCenterBannerContent() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${MEDIACENTERBANNER}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  /**
   * get Island Groups
   */
  getIslandGroups() {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${ISLANDGROUPS}`)
      .toPromise()
      .then((data) => {
        return this.updateUri(data);
      });
  }
  /**
   * Island Group Details
   * @param id
   */
  getIslandGroupDetails(id: any) {
    return this.http
      .get<any>(`${environment.apiBaseURL.toLowerCase()}/${ISLANDGROUPSDETAILS}/${id}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }

  /**
   * popular search keywords
   */
  getPopularSearchKeywords(languaget: any) {
    let language = localStorage.getItem('language');
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    return this.http
      .get<any>(`${environment.adminBaseURL.toLowerCase()}/${POPULAR_SEARCH_KEYWORDS}/${language.toLowerCase()}`)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  getTestiMonial() {
    return this.http
      .get<any>(`${environment.adminBaseURL.toLowerCase()}/${TESTIMONIAL}${FormatJson}`)
      .toPromise()
      .then((data) => {
        return this.updateUri(data);
      });
  }
  public getBlogListing(): Observable<any> {
    return this.http.get<any>(`${environment.apiBaseURL.toLowerCase()}/${BLOGLISTINGPAGE}`);
  }
  patchOldLikesCount() {
    let url = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=0?_format=json`;
    let url1 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=1?_format=json`;
    let url2 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=2?_format=json`;
    let url3 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=3?_format=json`;
    let url4 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=4?_format=json`;
    let url5 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=5?_format=json`;
    let url6 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=6?_format=json`;
    let url7 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=7?_format=json`;
    let url8 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=8?_format=json`;
    let url9 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=9?_format=json`;
    let url10 = `${environment.adminBaseURL.toLowerCase()}/highlights_latest_list_desc/en/?page=10?_format=json`;
    let arr: any = [];
    this.http
      .get<any>(url)
      .toPromise()
      .then((data) => {
        arr = [...arr, ...data.results];
        this.http
          .get<any>(url1)
          .toPromise()
          .then((data) => {
            arr = [...arr, ...data.results];
            this.http
              .get<any>(url2)
              .toPromise()
              .then((data) => {
                arr = [...arr, ...data.results];
                this.http
                  .get<any>(url3)
                  .toPromise()
                  .then((data) => {
                    arr = [...arr, ...data.results];
                    this.http
                      .get<any>(url4)
                      .toPromise()
                      .then((data) => {
                        arr = [...arr, ...data.results];
                        this.http
                          .get<any>(url5)
                          .toPromise()
                          .then((data) => {
                            arr = [...arr, ...data.results];
                            this.http
                              .get<any>(url6)
                              .toPromise()
                              .then((data) => {
                                arr = [...arr, ...data.results];
                                this.http
                                  .get<any>(url7)
                                  .toPromise()
                                  .then((data) => {
                                    arr = [...arr, ...data.results];
                                    this.http
                                      .get<any>(url8)
                                      .toPromise()
                                      .then((data) => {
                                        arr = [...arr, ...data.results];
                                        this.http
                                          .get<any>(url9)
                                          .toPromise()
                                          .then((data) => {
                                            arr = [...arr, ...data.results];
                                            this.http
                                              .get<any>(url10)
                                              .toPromise()
                                              .then((data) => {
                                                arr = [...arr, ...data.results];
                                                arr.forEach((item: any) => {
                                                  let urllike =
                                                    `${environment.adminBaseURL.toLowerCase()}/${ANONYMOUS_BLOG_LIKE}${FormatJson}` +
                                                    '&nnid=' +
                                                    item.nid;
                                                  this.http
                                                    .get<any>(urllike)
                                                    .toPromise()
                                                    .then((data) => {
                                                      const headers = {
                                                        headers: {
                                                          'X-CSRF-Token': this.authenticationService.getCRFSToken(),
                                                          Authorization:
                                                            'Bearer ' + this.authenticationService.getToken(),
                                                        },
                                                      };
                                                      const urlk = `${environment.adminBaseURL.toLowerCase()}/${NODE}`;
                                                      this.http
                                                        .patch(
                                                          `${urlk}/${item.nid}${FormatJson}`,
                                                          {
                                                            type: [{ target_id: 'highlights' }],
                                                            field_liked_count: [{ value: data.like_count }],
                                                          },
                                                          headers
                                                        )
                                                        .toPromise()
                                                        .then((data) => {});
                                                    });
                                                });
                                              });
                                          });
                                      });
                                  });
                              });
                          });
                      });
                  });
              });
          });
      });
  }
  getLikesCountWithoutLogin(nodeid: any) {
    let url = `${environment.adminBaseURL.toLowerCase()}/${ANONYMOUS_BLOG_LIKE}${FormatJson}` + '&nnid=' + nodeid;
    return this.http
      .get<any>(url)
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  getLikesCount(nodeid: any, uid: any) {
    let url = `${environment.adminBaseURL.toLowerCase()}/${BLOGLIKE}${FormatJson}` + '&nnid=' + nodeid + '&uid=' + uid;
    const headers = {
      headers: {
        'X-CSRF-Token': this.authenticationService.getCRFSToken(),
        Authorization: 'Bearer ' + this.authenticationService.getToken(),
      },
    };
    return (
      this.http
        //Remove headers
        // .get<any>(url, headers)
        .get<any>(url)
        .toPromise()
        .then((data) => {
          return data;
        })
    );
  }
  updateLikesCount(data: any, type: any, liked_nid: any) {
    const headers = {
      headers: {
        'X-CSRF-Token': this.authenticationService.getCRFSToken(),
        Authorization: 'Bearer ' + this.authenticationService.getToken(),
      },
    };
    const url = `${environment.adminBaseURL.toLowerCase()}/${NODE}`;
    if (type == 'post') {
      return this.http.post(`${url}${FormatJson}`, data, headers);
    } else {
      return this.http.patch(`${url}/${liked_nid}${FormatJson}`, data, headers);
    }
  }
  updateLikesHighlightCount(nid: any, count: any) {
    const headers = {
      headers: {
        'X-CSRF-Token': this.authenticationService.getCRFSToken(),
        Authorization: 'Bearer ' + this.authenticationService.getToken(),
      },
    };
    const url = `${environment.adminBaseURL.toLowerCase()}/${NODE}`;
    return this.http.patch(
      `${url}/${nid}${FormatJson}`,
      {
        type: [{ target_id: 'highlights' }],
        field_liked_count: [{ value: count }],
      },
      headers
    );
  }

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({ lat: resp.coords.latitude, lng: resp.coords.longitude });
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getopenweathermap(lati: number, lng: number) {
    return this.http
      .get<any>(
        environment.weatherURL +
          'data/2.5/forecast?lat=' +
          lati +
          '&lon=' +
          lng +
          '&units=metric&appid=93b9972cf83807b1f4451614370b9334'
      )
      .toPromise()
      .then((data) => {
        return data;
      });
  }

  getopenweathermaptmpc(lati: number, lng: number) {
    return this.http
      .get<any>(
        environment.weatherURL +
          'data/2.5/weather?lat=' +
          lati +
          '&lon=' +
          lng +
          '&units=metric&appid=93b9972cf83807b1f4451614370b9334'
      )
      .toPromise()
      .then((datar) => {
        return datar;
      });
  }

  tockencheck(user_id: number, timer: string, token: string) {
    return this.http
      .get<any>(
        `${environment.adminBaseURL.toLowerCase()}` +
          '/tocken_validate/?_format=json&token=' +
          token +
          '&user=' +
          user_id +
          '&timestamp=' +
          timer
      )
      .toPromise()
      .then((data) => {
        return data;
      });
  }
  changePassword(context: any, userid: number, username: string) {
    return this.http.post(environment.adminBaseURL.toLowerCase() + '/api/user/profile/update-password', {
      new_pass: context.password,
      user_id: userid,
      name: username,
    });
  }
  activateUser(val: any) {
    return this.http
      .get<any>(`${environment.adminBaseURL.toLowerCase()}/api/user-activation${val}`)
      .toPromise()
      .then(
        (data) => {
          return data;
        },
        (err) => {
          return '';
        }
      );
  }
}
